import { memo } from 'react';

import { cn } from '@/lib/utils';

const LOADING_WORD = 'ATAS DIGITAIS';

type SplashScreenProps = {
  visible: boolean;
  variant?: 'initial' | 'post-login';
  subtitle?: string;
};

export const SplashScreen = memo(({ visible, variant = 'initial', subtitle }: SplashScreenProps) => {
  const letters = LOADING_WORD.split('');

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-background transition-opacity duration-500 ease-out',
        visible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        variant === 'post-login' && 'bg-background/95 backdrop-blur'
      )}
      aria-live="polite"
      role="status"
    >
      <img
        src="/logo-stant.svg"
        alt="Stant"
        className={cn(
          'w-40 h-auto transform-gpu transition-all duration-700 ease-out dark:brightness-0 dark:invert',
          visible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        )}
      />

      <div className="flex items-end justify-center gap-1 text-base font-medium uppercase tracking-[0.3em] text-foreground">
        {letters.map((letter, index) => (
          <span
            key={`${letter}-${index}`}
            className={cn(
              'wave-letter select-none text-lg md:text-xl',
              letter === ' ' ? 'wave-space' : `wave-delay-${index}`
            )}
            aria-hidden="true"
          >
            {letter}
          </span>
        ))}
      </div>

      {subtitle && (
        <p className="text-sm text-muted-foreground transition-opacity duration-500">
          {subtitle}
        </p>
      )}
    </div>
  );
});

SplashScreen.displayName = 'SplashScreen';


